// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `custom-header .search {
  background: #ffffff;
  width: 0;
  overflow: hidden;
  transition: ease all 0.5s;
  -moz-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  position: fixed;
  display: flex;
  align-content: center;
  height: 100%;
  right: 0;
  top: 0;
  opacity: 0;
  z-index: 999;
}
custom-header .active {
  width: 100%;
  opacity: 1;
}
custom-header .safe {
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
}
custom-header ion-item {
  --background: transparent !important;
  margin: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-header/custom-header.component.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,8BAAA;EACA,6BAAA;EACA,iCAAA;EACA,eAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;AAAJ;AAGE;EACE,WAAA;EACA,UAAA;AADJ;AAIE;EACE,yCAAA;EACA,oCAAA;AAFJ;AAKE;EACE,oCAAA;EACA,sBAAA;AAHJ","sourcesContent":["custom-header {\n  .search {\n    background: #ffffff;\n    width: 0;\n    overflow: hidden;\n    transition: ease all 0.5s;\n    -moz-transition: ease all 0.5s;\n    -ms-transition: ease all 0.5s;\n    -webkit-transition: ease all 0.5s;\n    position: fixed;\n    display: flex;\n    align-content: center;\n    height: 100%;\n    right: 0;\n    top: 0;\n    opacity: 0;\n    z-index: 999;\n  }\n\n  .active {\n    width: 100%;\n    opacity: 1;\n  }\n\n  .safe {\n    margin-top: constant(safe-area-inset-top);\n    margin-top: env(safe-area-inset-top);\n  }\n\n  ion-item {\n    --background: transparent !important;\n    margin: 0px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
